export default __webpack_public_path__ + "e37e2aefc829424ad20aa4ed9dfbfe20b657a2efd64436465e43d02cb4e7fe42.svg";